import React from 'react'
import { useSelector } from 'react-redux'
import classnames from 'classnames'
import moment from 'moment'

export function DrugTests() {
  const { drug_tests, organization, resident, config } = useSelector(state=>state)
  function badgeClassnames(drug_test){
    return classnames("badge",{ 
      "badge-success": ['Passed','Negative'].includes(drug_test.result),
      "badge-danger": ['Failed','Positive'].includes(drug_test.result),
    })
  }

  const sender = `${config.root_url}organizations/${organization.name}/residents/${resident.id}`
  const hrefFor = (drug_test) => `/organizations/${organization.name}/drug_tests/${drug_test.id}?sender_name=${resident.name}&sender=${sender}`
  return (
    <div>
      {
        drug_tests.map(drug_test => (
          <a key={drug_test.id} className="p-4 border-bottom d-block text-black" href={hrefFor(drug_test)}>
            <div className="d-flex justify-content-between align-items-center">
              <b>{drug_test.kind || 'No Kind Set'}</b>
              <div className={badgeClassnames(drug_test)}>{drug_test.result}</div>
            </div>
            <div>{!!drug_test.performed_at ? moment(drug_test.performed_at).format("MM/DD/YYYY") : 'n/a'}</div>
          </a>
        ))
      }
    </div>
  )
}
